import React, { Component } from "react";
import PropTypes from "prop-types";
import "./atlas.css";
import "antd/dist/antd.css";
import Editor from "./editor";
import clickEdit from "./CmClickEdit"
import { Row, Col, Checkbox, Tooltip, Modal, Icon, Carousel } from "antd";
const viewNum = <span>浏览量</span>;
const likeNum = <span>点赞量</span>;
const transmitNum = <span>转发量</span>;

export default class AtlasList extends Component {
  // 默认属性
  static defaultProps = {
    newSecondSelectColor: "#0050B3",
  };
  // 静态类型分析
  static propTypes = {
    coverPic: PropTypes.string.isRequired, //图片
    title: PropTypes.string.isRequired, //标题
    desc: PropTypes.string.isRequired, //描述
    source: PropTypes.string.isRequired, //来源
    status: PropTypes.number.isRequired, //状态
    newTime: PropTypes.string.isRequired, //时间
    viewNum: PropTypes.number.isRequired, //浏览量
    likeNum: PropTypes.number.isRequired, //点赞量
    forwardNum: PropTypes.number.isRequired, //转发量
    mediaFusionId: PropTypes.number.isRequired, //删除id
    id: PropTypes.number.isRequired, //id
    type: PropTypes.number.isRequired, //删除type
  };
  constructor(props) {
    super(props);
    this.state = {
      bigImgVisible: false,
      delVisible: false,
      desc: "",
    };
  }

  // 预览大图
  showModal = () => {
    this.setState({
      bigImgVisible: true,
      desc: this.props.desc,
    });
  };
  // 点击编辑拿到父组件的方法
  showModal2 = () => {
    // this.props.getAllReports();
    // this.props.filterCheckedColumns();
    // this.props.getFindIds(this.props.id);
    // this.refs.editor.showModal();
    clickEdit.gotoPage(this.props.type, this.props.id);
  };
  bigImgOk = (e) => {
    console.log(e);
    this.setState({
      bigImgVisible: false,
    });
  };

  bigImgCancel = (e) => {
    console.log(e);
    this.setState({
      bigImgVisible: false,
    });
  };
  // 删除
  showModa3 = () => {
    this.setState({
      delVisible: true,
    });
  };
  delOk = (e) => {
    this.props.myClick();
    this.setState({
      delVisible: false,
    });
  };

  delCancel = (e) => {
    console.log(e);
    this.setState({
      delVisible: false,
    });
  };

  render() {
    let status = this.props.status;
    let statusJudge;
    // 判断删除、撤回状态
    if (status === 2) {
      statusJudge = (
        <Col
          span={2}
          style={{ textAlign: "center", cursor: "pointer", color: "#999", marginTop: "20px" }}
        >
          <div
            style={{ color: "#337ab7" }}
            onClick={this.recall}
          >
            撤回
          </div>
        </Col>
      );
    } else {
      statusJudge = (
        <Col
          span={2}
          style={{ textAlign: "center", cursor: "pointer", color: "#999", marginTop: "20px" }}
        >
          <div
            style={{
              color: `${this.props.newSecondSelectColor}`,
              marginBottom: "10px",
              cursor: "pointer",
            }}
            onClick={this.showModal2}
          >
            <span style={{ color: "#337ab7" }}>
              编辑
            </span>
          </div>
          {/* 编辑组件 */}
          <Editor
            ref="editor"
            img={this.props.coverPic}
            desc={this.props.desc}
            title={this.props.title}
            pictureList={this.props.pictureList}
            labelNames={this.props.labelNames}
            columnList={this.props.columnList}
            userDate={this.props.userDate}
            filterColumn={this.props.filterColumn}
            myAlter={(txtText) => this.alter(txtText)}
            getAllReports={() => this.props.getAllReports()}
            getEditorColumnLists={() => this.props.getEditorColumnLists()}
            editorColumnList={this.props.editorColumnList}
          />
          <div style={{ color: "red" }} onClick={this.showModa3}>
            删除
          </div>
          <Modal
            title="信息"
            visible={this.state.delVisible}
            onOk={this.delOk}
            onCancel={this.delCancel}
            centered
            width="300px"
          >
            确定删除吗？
          </Modal>
        </Col>
      );
    }
    return (
      <div
        style={{
          backgroundColor: "#fff",
        }}
      >
        <div
          style={{
            borderBottom: "1px solid #ccc",
            padding: "5px",
            marginTop: "5px",
          }}
        >
          <Row>
            <Col span={12}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <Checkbox
                  checked={this.props.checked} //拿到父组件内部子组件的checked方法
                  onClick={(e) => {
                    this.props.ItemClick(); //点击子组件时拿到父组件内部子组件的方法
                  }}
                />
                <div
                  className="atlasListPic"
                  style={{ marginLeft: "20px", position: "relative" }}
                  onClick={this.showModal}
                >
                  <img src={this.props.coverPic} alt="" />
                  <div
                    style={{
                      width: "40px",
                      height: "20px",
                      color: "#fff",
                      backgroundColor: "#00000099",
                      lineHeight: "20px",
                      textAlign: "center",
                      position: "absolute",
                      bottom: "3px",
                      right: "3px",
                      borderRadius: "5px",
                    }}
                  >
                    <Icon type="eye" style={{ marginRight: "2px" }} />
                    {this.props.pictureList.length}
                  </div>
                </div>
                <div style={{ display: "flex" }} onClick={this.showModal}>
                  <div style={{ margin: "0px 20px" }}>
                    <Icon type="check-circle" theme="filled" />
                  </div>
                  <div>
                    <div className="al-title">{this.props.title}</div>
                    <div className="altasTitle">{this.props.desc}</div>
                  </div>
                </div>
              </div>
            </Col>
            <Modal
              title={this.props.title}
              visible={this.state.bigImgVisible}
              onOk={this.bigImgOk}
              onCancel={this.bigImgCancel}
              bodyStyle={{ height: "580px" }}
              width="800px"
              footer={null}
            >
              <div
                className="viewImg"
                style={{ width: "780px", height: "560px" }}
              >
                <Carousel>
                  {this.props.pictureList.map((item, index) => {
                    return (
                      <div key={index}>
                        <img
                          src={item.path}
                          alt=""
                          width="750px"
                          height="540px"
                        />
                      </div>
                    );
                  })}
                </Carousel>
              </div>
              <div style={{ position: "absolute", left: "25px", bottom: "50px", overflow: "hidden", textOverflow: "ellipsis", lineClamp: 3, whiteSpace: "nowrap" }}>{this.state.desc}</div>
            </Modal>
            {/* </div> */}
            <Col span={2} style={{ textAlign: "center", color: "#999", marginTop: "35px" }}>
              {this.props.source ? "转载" : "原创"}
            </Col>
            <Col span={2} style={{ textAlign: "center", marginTop: "35px", overflow: "hidden", textOverflow: "ellipsis", lineClamp: 1, whiteSpace: "nowrap" }}>
              {this.props.labelNames.join(",")}
            </Col>
            <Col span={2} style={{ textAlign: "center", color: "#999", marginTop: "35px" }}>
              {(() => {
                switch (this.props.status) {
                  case "1": return "暂存"; break;
                  case "2": return "已发布"; break;
                  case "3": return "撤稿"; break;
                  case "4": return "发布失败"; break;
                  case "5": return "发布中"; break;
                  default: return null;
                }
              }
              )()}
            </Col>
            <Col span={2} style={{ textAlign: "center", color: "#999", marginTop: "35px" }}>
              {this.props.newTime}
            </Col>
            <Col
              span={2}
              style={{
                textAlign: "center",
                color: "#999",
                marginTop: "10px"
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ margin: "5px 0px" }}>
                  <span>
                    <Tooltip placement="left" title={viewNum}>
                      <Icon type="play-circle" theme="filled" />
                    </Tooltip>
                  </span>
                  <span style={{ marginLeft: "5px" }}>
                    {this.props.viewNum}
                  </span>
                </div>
                <div style={{ margin: "5px 0px" }}>
                  <span>
                    <Tooltip placement="left" title={likeNum}>
                      <Icon type="heart" theme="filled" />
                    </Tooltip>
                  </span>
                  <span style={{ marginLeft: "5px" }}>
                    {this.props.likeNum}
                  </span>
                </div>
                <div style={{ margin: "5px 0px" }}>
                  <span>
                    <Tooltip placement="left" title={transmitNum}>
                      <Icon type="share-alt" />
                    </Tooltip>
                  </span>
                  <span style={{ marginLeft: "5px" }}>
                    {this.props.forwardNum}
                  </span>
                </div>
              </div>
            </Col>
            {statusJudge}
          </Row>
        </div>
      </div>
    );
  }
  //  修改描述
  alter(txtText) {
    this.setState({
      desc: txtText,
    });
  }
  // 点击撤回
  recall = () => {
    this.props.getRecall(this.props.id);
  };
}
